import { useQuery } from 'react-query';

import { OwnerSummary } from '@savgroup-front-common/types';
import { OwnerService } from '@/api';

interface UseCookieReturnValues {
  ownerSummary?: OwnerSummary;
  ownerSummaryIsLoading: boolean;
}

const GetOwnerSummary = 'getOwnerSummary';

const useGetOwnerSummary = (): UseCookieReturnValues => {
  const { data: ownerSummary, isLoading: ownerSummaryIsLoading } = useQuery(
    [GetOwnerSummary],
    async () => {
      const response = await OwnerService.getOwnerSummaryQuery();

      if (!response) {
        return undefined;
      }

      try {
        return response.json();
      } catch (error) {
        return undefined;
      }
    },
    {
      retry: false,
      staleTime: Infinity,
    },
  );

  return {
    ownerSummary,
    ownerSummaryIsLoading,
  };
};

export default useGetOwnerSummary;
